<template>
    <div class="tour-settings">
        <div v-show="isLoadingmy " style="background: rgba(0,0,0,0.5);position: fixed;display: flex;justify-content:center;align-items:center;z-index: 1000001;left: 0;top: 0;height: 100%;width: 100%;">
            <img src="static/img/loader.gif" style="max-width:100px;"/>
        </div>
        <div class="tour-settings-content">
            <md-button class="md-icon-button close-tour-settings" @click="toggleShowSettings(false), toggleShowSettingsDummy()">
                <md-icon>clear</md-icon>
            </md-button>
            <md-tabs class="centered-title" md-border-bottom md-dynamic-height>
                <md-tab class="media-tab" md-label="General">
                    <div class="wrap scroll-list">
                        <p v-if="recordUpdateSucc" style="    color: green;    position: fixed;    float: right;    right: 6%;">Record updated successfully!</p>
                        <br><br><br>
                        <md-card-actions>
                            <md-button style="    color: green;    position: fixed;    float: right;    right: 6%; margin-top:-30px;" class="md-primary md-raised" v-if="TourSettingsChangedTets" type="submit" v-on:click="saveTour()">save</md-button>
                        </md-card-actions>
                        <section class="global-section">
                            <div class="md-layout md-gutter row">
                                <div class="col-3">
                                    <h2 class="section-title" style="font-size:18px">Default Trigger Setting</h2>
                                </div>
                                <div class="col-9">
                                    <md-field class="half-field">
                                        <label for="activate" style="pointer-events: auto;top: 0; opacity: 1; font-size: 12px;">Activate</label>
                                        <select v-model="tour.defaultActivate" name="activate" style="width: 100%; border-color:white;" id="activate" @change="something($event,'activate')">
                                            <option value="Enter">Enter</option>
                                            <option value="Exit">Exit</option>
                                            <option value="Proximity">Proximity</option>
                                        </select>
                                    </md-field>
                                    <md-field class="half-field">
                                        <label for="radius">Radius Distance</label>
                                        <md-input v-model="tour.defaultRadiusDistance" @keyup.native="something($event,'defaultRadiusDistance')" name="radius" id="radius" style="margin-bottom: -9px; width:50%"></md-input>
                                        <div class="md-errors-spacer"></div>
                                    </md-field>
                                    <md-field class="half-field">
                                        <label for="tolerance">Tolerance</label>
                                        <md-input v-model="tour.defaultTolerance" @keyup.native="something($event,'defaultTolerance')" name="tolerance" id="tolerance" style="margin-bottom: -9px;"></md-input>
                                        <div class="md-errors-spacer"></div>
                                        <div>
                                            <p v-if="toleranceerror" style="    color: red; font-size:12px;   position: absolute;    float: right;    right: 6%;  margin-top:35px;">Tolerance level must be between [30 and 360]</p>
                                        </div>
                                    </md-field>
                                    <md-field class="half-field md-has-value">
                                        <label for="delay">Delay</label>
                                        <md-input v-model="tour.defaultDelay" @keyup.native="something($event,'defaultDelay')" name="delay" id="delay" style="margin-bottom: -9px;"></md-input>
                                        <div class="md-errors-spacer"></div>
                                    </md-field>
                                </div>
                            </div>
                        </section>
                        <br><br>
                        <section class="global-section" style="margin-top:-15px">
                            <div class="md-layout md-gutter row">
                                <div class="col-4">
                                    <h2 class="section-title">Tour Time Zone</h2>
                                </div>
                                <div class="col-8">
                                    <md-field class="wide">
                                        <select v-model="tour.timezone_id" name="timezone" id="timezone" style="width: 100%; border-color:white; " @change="something($event,'timezone')">
                                            <option v-for="timezone in timezones" :value="timezone.id" :key="timezone.timezone">{{ timezone.timezone }}</option>
                                        </select>
                                    </md-field>
                                    <md-card-actions></md-card-actions>
                                </div>
                            </div>
                        </section>
                        <section class="global-section">
                            <div class="md-layout md-gutter row">
                                <div class="col-4">
                                    <h2 class="section-title">Channels </h2>
                                </div>
                                <div class="col-8 align-col">
                                    <md-list class="draggable-list selectable">

                                        <draggable
                                            :tourLanguages="tourLanguages"
                                            :disabled="!enabled"
                                            class="list-group"
                                            ghost-class="ghost"
                                            :move="checkMove"
                                            @start="dragging = true"
                                            v-model="sortedLanguages" @end="updateLanguages()"
                                        >

                                            <div
                                                class="list-group-item"
                                                v-for="(lang, itemObjKey) in tourLanguages"
                                                :key="lang.language"
                                            >
                                                <span style="float: left;position: absolute; margin-left: -6%;    margin-top: 16px;    font-size: 21px">
                                                    {{ itemObjKey + 1 }}.
                                                </span>
                                                <div class="as-sortable-item">
                                                    <div role="button" class="as-sortable-item-handle">
                                                        <md-icon>drag_handle</md-icon>
                                                    </div>
                                                    <em style="margin-left:100px">{{ lang.language }}</em>
                                                    <md-button @click="confirmDelete(lang)" class="delete-btn md-icon-button" style="margin-top:0px">
                                                        <md-icon>delete</md-icon>
                                                    </md-button>
                                                </div>
                                            </div>
                                        </draggable>
                                    </md-list>
                                    <md-button @click="addAllLangauge()" class="md-icon-button md-primary md-raised add-channel">
                                        <md-icon>add</md-icon>
                                    </md-button>
                                </div>
                            </div>
                            <md-dialog :md-active.sync="showDialog" class="small-modal OverflowShowDialog">
                                <header>
                                    <h2>Add Languages</h2>
                                    <md-button class="md-icon-button" @click="showDialog = false">
                                        <md-icon>clear</md-icon>
                                    </md-button>
                                </header>
                                <md-list class="scroll-listmy">
                                    <md-list-item v-for="lang in languages" :key="lang.code">
                                        <md-checkbox v-model="addLanguages" :value="lang.id" class="language-checkbox" :disabled="disableLanguage(lang.id)">{{ lang.language }}</md-checkbox>
                                        <span v-if="activeItem === lang.id">You have exceed the maximum number of supported languages (60). Please reduce the number of languages selected to proceed</span>
                                    </md-list-item>
                                </md-list>
                                <md-dialog-actions class="full-btn">
                                    <md-button class="md-raised md-primary" @click="addTourLanguages()">ADD</md-button>
                                </md-dialog-actions>
                            </md-dialog>
                        </section>
                    </div>
                </md-tab>
                <md-tab class="media-tab" md-label="Media">
                    <div class="wrap scroll-list">
                        <div class="inner-wrap">
                            <section class="media-section ng-scope">
                                <md-list>
                                    <md-list-item md-expand v-for="type in ['Filler', 'Music', 'Notification', 'Safety']" :key="type">
                                        <div class="line-item title-line hovered-line">
                                            <div class="left-item changeFontSize">
                                                <div class="el"><strong class="ng-binding ">{{ type }}</strong></div>
                                            </div>
                                            <div class="right-item">
                                                <div class="">
                                                    <md-button @click="openMediaDialog(type)" title="Add Media" class="md-icon-button md-fab md-primary top-index">
                                                        <md-icon>add</md-icon>
                                                    </md-button>
                                                </div>
                                            </div>
                                        </div>
                                        <md-list slot="md-expand">
                                            <li v-if="library.length == 0 || library[type.toLowerCase()].length == 0" class="moveLeftContent">No item found</li>
                                            <div v-if="type === 'Safety'">
                                                <draggable
                                                    :list="convertObjToSafety"
                                                    :disabled="!enabled"
                                                    class="list-group"
                                                    ghost-class="ghost"
                                                    :move="checkMove"
                                                    @update="onUpdate('Safety')"
                                                    @start="dragging = true"
                                                    @end="endDragging(false)"
                                                    title="Update sequence of story file"
                                                >
                                                    <div class="line-item hovered-line" v-for="(item, index) in library[type.toLowerCase()]">
                                                        <div v-if="index">
                                                            <div class="left-item">
                                                                <div class="el ng-binding moveLeftContent">{{ index }}</div>
                                                            </div>
                                                            <div class="right-item">
                                                                <div class="">
                                                                    <md-button class="md-icon-button delete-btn md-button md-ink-ripple" title="Remove Channel" @click="confirmDeleteMedia(type, index)">
                                                                        <md-icon>delete</md-icon>
                                                                    </md-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <div class="left-item">
                                                                <div class="el ng-binding">No content</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </draggable>
                                            </div>
                                            <div v-else-if="type === 'Filler'">
                                                <draggable
                                                    :list="convertObjToFiller"
                                                    :disabled="!enabled"
                                                    class="list-group"
                                                    ghost-class="ghost"
                                                    :move="checkMove"
                                                    @update="onUpdate('Filler')"
                                                    @start="dragging = true"
                                                    @end="endDragging(false)"
                                                    title="Update sequence of story file"
                                                >
                                                    <div class="line-item hovered-line" v-for="(item, index) in library[type.toLowerCase()]">
                                                        <div v-if="index">
                                                            <div class="left-item">
                                                                <div class="el ng-binding moveLeftContent">{{ index }}</div>
                                                            </div>
                                                            <div class="right-item">
                                                                <div class="">
                                                                    <md-button class="md-icon-button delete-btn md-button md-ink-ripple" title="Remove Channel" @click="confirmDeleteMedia(type, index)">
                                                                        <md-icon>delete</md-icon>
                                                                    </md-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <div class="left-item">
                                                                <div class="el ng-binding">No content</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </draggable>
                                            </div>
                                            <div v-else-if="type === 'Music'">
                                                <draggable
                                                    :list="convertObjToMusic"
                                                    :disabled="!enabled"
                                                    class="list-group"
                                                    ghost-class="ghost"
                                                    :move="checkMove"
                                                    @update="onUpdate('Music')"
                                                    @start="dragging = true"
                                                    @end="endDragging(false)"
                                                    title="Update sequence of story file"
                                                >
                                                    <div class="line-item hovered-line" v-for="(item, index) in library[type.toLowerCase()]">
                                                        <div v-if="index">
                                                            <div class="left-item">
                                                                <div class="el ng-binding moveLeftContent">{{ index }}</div>
                                                            </div>
                                                            <div class="right-item">
                                                                <div class="">
                                                                    <md-button class="md-icon-button delete-btn md-button md-ink-ripple" title="Remove Channel" @click="confirmDeleteMedia(type, index)">
                                                                        <md-icon>delete</md-icon>
                                                                    </md-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <div class="left-item">
                                                                <div class="el ng-binding">No content</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </draggable>
                                            </div>
                                            <div v-else>
                                                <div class="line-item hovered-line" v-for="(item, index) in library[type.toLowerCase()]">
                                                    <div v-if="index">
                                                        <div class="left-item">
                                                            <div class="el ng-binding moveLeftContent">{{ index }}</div>
                                                        </div>
                                                        <div class="right-item">
                                                            <div class="">
                                                                <md-button class="md-icon-button delete-btn md-button md-ink-ripple" title="Remove Channel" @click="confirmDeleteMedia(type, index)">
                                                                    <md-icon>delete</md-icon>
                                                                </md-button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div class="left-item">
                                                            <div class="el ng-binding">No content</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </md-list>
                                    </md-list-item>
                                </md-list>
                                <md-dialog :md-active.sync="showMediaDialog" class="small-modal" style="height:350px; width: 448px">
                                    <header>
                                        <h2>Add {{ mediaDialogType }} Files</h2>
                                        <md-button class="md-icon-button" @click="showMediaDialog = false">
                                            <md-icon>clear</md-icon>
                                        </md-button>
                                    </header>
                                    <md-list class="scroll-list" style="height:100%;">
                                        <md-list-item v-for="media in assignableMedia" :key="media.friendly_name">
                                            <md-checkbox v-model="addMedia" :value="media.friendly_name" :key="media.friendly_name">{{ media.friendly_name }}</md-checkbox>
                                        </md-list-item>

                                        <md-list-item v-if="assignableMedia.length === 0">Add file for all channels</md-list-item>

                                        <md-list-item v-if="assignableMedia.length < 0">No files available in your Library.</md-list-item>
                                    </md-list>
                                    <md-dialog-actions class="full-btn">
                                        <md-button v-show="addMedia.length > 0" class="md-raised md-primary" @click="addTourMedia(mediaDialogType)">ADD</md-button>
                                    </md-dialog-actions>
                                </md-dialog>
                            </section>
                        </div>
                    </div>
                </md-tab>
            </md-tabs>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to delete <b>{{ langDelete.language }}</b>? This action cannot be undone.
            </md-dialog-content>
            <md-dialog-actions class="full-btnDelete">
                <md-button class="ManualBtn ManualBtndelete" @click="removeLanguage(langDelete.id)">Delete</md-button>
                <button class="ManualBtn ManualBtncancel extraClass" @click="closeDialog()">CANCEL</button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="checkRouteIsMappingTable">
            <md-dialog-title>
                Important Information
            </md-dialog-title>
            <md-dialog-content>
                Channels are associated with tour. Are you sure you want to delete <b>{{ langDelete.language }}</b>? This action cannot be undone.
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="removeLanguageAfterConfirmation (langDelete.id)">Delete</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="checkRouteIsMappingTableOk">Ok</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogMedia">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to delete this Media<b></b>? This action cannot be undone.
            </md-dialog-content>
            <md-dialog-actions class="full-btnDelete">
                <md-button class="ManualBtn ManualBtndelete" @click="removeTourMedia (categoryDelete, friendlyNameDelete)">Delete</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="closeDialog()">Cancel</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import {mapGetters, mapActions} from 'vuex';
import {saveTour} from '../../services/EditorService.js';

export default {
  components: {
    draggable: draggable
  },
  expand: {},
  data: () => ({
    showDialogCheck: false,
    activeItem: 0,
    recordUpdateSucc: false,
    clickSaveBtn: false,
    TourSettingstimezone: false,
    toleranceerror: false,
    TourSettingsChangedTets: false,
    isLoadingmy: false,
    enabled: true,
    dragging: false,
    showDeleteDialog: false,
    showDeleteDialogMedia: false,
    langDelete: [],
    categoryDelete: [],
    friendlyNameDelete: [],
    addLanguages: [],
    disableLanguages: [],
    addMedia: [],
    mediaDialogType: null,
    showDialog: false,
    showMediaDialog: false,
    showInfo: false,
    form: {
      activate: '',
      delay: '',
      radius: '',
      tolerance: ''
    },
    tourSaved: false,
    ArrayinUse: [],
    dataexte: [
      {Id: 1, Name: 'Video 1', Content: ['Humor 1', 'Music 1', 'Movies 1', 'TV Shows 1']},
      {Id: 2, Name: 'Video 2', Content: ['Humor 2', 'Music 2', 'Movies 2', 'TV Shows 2']},
      {Id: 3, Name: 'Video 3', Content: ['Humor 3', 'Music 3', 'Movies 3', 'TV Shows 3']}
    ],
    defaultTriSet: {}
  }),
  computed: {
    ...mapGetters('client', ['currentClient']),
    ...mapGetters('tours', {tour: 'currentTour'}),
    ...mapGetters('tours', ['TourSettingsChanged']),
    ...mapGetters('language', {languages: 'getLanguageList', tourLanguages: 'getTourLanguageList', reordered: 'tourLanguagesReordered', checkRouteIsMappingTable: 'checkRouteIsMappingTable'}),
    ...mapGetters('library', {assignableMedia: 'getAssignableMedia', library: 'getTourLibrary'}),
    ...mapGetters('timezone', {timezones: 'getTimezones'}),

    convertObjToSafety () {
      var obj = this.library.safety;
      if (obj !== undefined) {
        var array = Object.entries(obj).map(([key, value]) => ({[key]: value}));
        return array;
      }
    },
    convertObjToFiller () {
      var obj = this.library.filler;
      if (obj !== undefined) {
        var array = Object.entries(obj).map(([key, value]) => ({[key]: value}));
        return array;
      }
    },
    convertObjToMusic () {
      var obj = this.library.music;
      if (obj !== undefined) {
        var array = Object.entries(obj).map(([key, value]) => ({[key]: value}));
        return array;
      }
    },
    sortedLanguages: {
      get: function () {
        return this.tourLanguages;
      },
      set: function (value) {
        this.updateLanguageOrder({languages: value});
      }
    }
  },
  watch: {
    addLanguages () {
      // this.addLanguages.pop();
      if (this.addLanguages.length > 60) {
        let lastValue = this.addLanguages.pop();
        this.activeItem = lastValue;
        this.showDialogCheck = true;
      }
      if (this.addLanguages.length < 60) {
        this.activeItem = null;
      }
    }
  },
  methods: {
    ...mapActions('editor', ['toggleShowSettings']),
    ...mapActions('language', ['loadLanguageList', 'loadTourLanguageList', 'addTourLanguage', 'removeTourLanguage', 'removeTourLanguages', 'setTourLanguageList', 'updateLanguageOrder', 'updateTourLanguages', 'changeStateRouteIsMappingTable']),
    ...mapActions('library', ['addMediaToTour', 'loadAssignableMedia', 'loadTourLibrary', 'removeMediaFromTour', 'loadTourNotifications', 'reorderTourLibrary']),
    ...mapActions('timezone', ['loadTimezones']),
    ...mapActions('routes', ['loadRoutes']),
    ...mapActions('tours', ['updateCurDupli', 'updateCheckTourSettingSave']),
    checkMove: function (e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    something (event, defaultVal) {
      var defaultTriSetP;
      var checkData = false;
      if (defaultVal === 'defaultRadiusDistance') {
        checkData = true;
        defaultTriSetP = this.defaultTriSet.defaultRadiusDistance;
      }
      if (defaultVal === 'defaultTolerance') {
        if (event.target.value > 29 && event.target.value < 361) {
          defaultTriSetP = this.defaultTriSet.defaultTolerance;
          this.toleranceerror = false;
          this.TourSettingsChangedTets = true;
          checkData = true;
        } else {
          this.toleranceerror = true;
          this.TourSettingsChangedTets = false;
          return false;
        }
      }
      if (defaultVal === 'defaultDelay') {
        checkData = true;
        defaultTriSetP = this.defaultTriSet.defaultDelay;
      }
      if (defaultVal === 'activate') {
        checkData = true;
        defaultTriSetP = this.defaultTriSet.activate;
      }
      if (defaultVal === 'timezone') {
        checkData = true;
        defaultTriSetP = this.defaultTriSet.timezone;
      }
      if ((Number(event.target.value) !== Number(defaultTriSetP)) && checkData === true) {
        if (this.toleranceerror === true) {
          this.TourSettingsChangedTets = false;
        } else {
          this.TourSettingsChangedTets = true;
        }
      }
    },
    toggleShowSettingsDummy () {
      if (this.TourSettingsChangedTets === true) {
        this.tour.defaultActivate = this.defaultTriSet.defaultActivate;
        this.tour.defaultDelay = this.defaultTriSet.defaultDelay;
        this.tour.defaultRadiusDistance = this.defaultTriSet.defaultRadiusDistance;
        this.tour.defaultTolerance = this.defaultTriSet.defaultTolerance;
        this.tour.timezone_id = this.defaultTriSet.timezone_id;
        this.TourSettingsChangedTets = false;
      }
    },
    addAllLangauge () {
      this.showDialogCheck = false;
      this.addLanguages = [];
      this.activeItem = null;
      for (let index = 0; index < this.tourLanguages.length; index++) {
        const element = this.tourLanguages[index]['id'];
        this.addLanguages.push(element);
      }
      this.showDialog = true;

      // disable the selected langauge in the add languages modal
      this.tourLanguages.forEach(tourLanguage => {
        this.disableLanguages.push(tourLanguage.id);
      });
    },
    endDragging (dragging) {
      dragging = false;
    },
    onUpdate (cate) {
      this.isLoadingmy = true;
      this.savelistTourMediaOrder(cate);
    },
    async savelistTourMediaOrder (cate) {
      if (cate === 'Filler') {
        this.ArrayinUse = this.convertObjToFiller;
      } else if (cate === 'Safety') {
        this.ArrayinUse = this.convertObjToSafety;
      } else {
        this.ArrayinUse = this.convertObjToMusic;
      }
      this.reorderTourLibrary({
        'clientId': this.currentClient.id,
        'tourId': this.tour.id,
        'newArray': this.ArrayinUse,
        'cate': cate
      }).then(() => {
        this.isLoadingmy = false;
      });
    },
    async checkRouteIsMappingTableOk () {
      this.changeStateRouteIsMappingTable(false);
    },
    saveTour () {
      this.recordUpdateSucc = true;
      this.clickSaveBtn = true;
      this.TourSettingsChangedTets = false;
      this.defaultTriSet.defaultActivate = this.tour.defaultActivate;
      this.defaultTriSet.defaultDelay = this.tour.defaultDelay;
      this.defaultTriSet.defaultRadiusDistance = this.tour.defaultRadiusDistance;
      this.defaultTriSet.defaultTolerance = this.tour.defaultTolerance;
      this.defaultTriSet.timezone_id = this.tour.timezone_id;
      saveTour(this.tour);
      this.updateCheckTourSettingSave(this.defaultTriSet);
      setTimeout(() => {
        this.recordUpdateSucc = false;
      }, 3000);
    },
    confirmDelete (lang) {
      this.showDeleteDialog = true;
      this.langDelete = lang;
      this.disableLanguages.pop(lang);
    },
    confirmDeleteMedia (category, friendlyName) {
      this.showDeleteDialogMedia = true;
      this.categoryDelete = category;
      this.friendlyNameDelete = friendlyName;
    },
    closeDialog () {
      this.showDeleteDialog = false;
      this.showDeleteDialogMedia = false;
      this.langDelete = [];
      this.categoryDelete = [];
      this.friendlyNameDelete = [];
    },
    addTourLanguages () {
      let pForThis = this;
      let addnewLanguageOrder = [];
      for (let lang of this.tourLanguages) {
        addnewLanguageOrder.push({
          id: lang.id,
          order: lang.order
        });
      }
      this.addTourLanguage({tourId: this.tour.id, addLanguages: this.addLanguages, languageOrder: addnewLanguageOrder}).then((data) => {
        this.loadRoutes(this.tour.id);
        pForThis.loadRoutes(this.tour.id);
        pForThis.loadTourLibrary({clientId: pForThis.currentClient.id, tourId: pForThis.tour.id}).then((data) => {
          this.addLanguagesAfterSaving = this.addLanguages;
          this.showDeleteDialogMedia = false;
        });
      });
      this.showDialogCheck = true;
      this.showDialog = false;
    },
    addTourMedia (category) {
      let pForThisfoagin = this;
      this.addMediaToTour({
        clientId: this.currentClient.id,
        tourId: this.tour.id,
        friendly_names: this.addMedia,
        category: category
      }).then((data) => {
        let pForThis = pForThisfoagin;
        pForThis.loadTourLibrary({clientId: pForThis.currentClient.id, tourId: pForThis.tour.id}).then((data) => {
          pForThis.addMedia = [];
          pForThis.showMediaDialog = false;
          pForThis.loadTourNotifications({tourId: pForThis.tour.id, clientId: pForThis.currentClient.id});
        });
      });
    },
    removeLanguage (languageId) {
      let pForThis = this;
      var index = pForThis.addLanguages.indexOf(languageId);
      pForThis.addLanguages.splice(index, 1);
      this.removeTourLanguage({tourId: this.tour.id, languageId: languageId}).then((data) => {
        pForThis.loadRoutes(this.tour.id);
        pForThis.loadTourLibrary({clientId: pForThis.currentClient.id, tourId: pForThis.tour.id}).then((data) => {
          this.showDeleteDialogMedia = false;
        });
      });
      this.loadTourNotifications({tourId: this.tour.id, clientId: this.currentClient.id});
      this.categoryDelete = [];
      this.friendlyNameDelete = [];
      this.showDialog = false;
      this.showDeleteDialog = false;
    },
    removeTourMedia (category, friendlyName) {
      this.removeMediaFromTour({
        category: category,
        clientId: this.currentClient.id,
        tourId: this.tour.id,
        friendlyName: friendlyName
      }).then((data) => {
        this.loadTourLibrary({clientId: this.currentClient.id, tourId: this.tour.id}).then((data) => {
          this.showDeleteDialogMedia = false;
        });
        this.loadTourNotifications({tourId: this.tour.id, clientId: this.currentClient.id});
        this.categoryDelete = [];
        this.friendlyNameDelete = [];
      });
    },
    openMediaDialog (type) {
      let varForThis = this;
      this.loadAssignableMedia({clientId: this.currentClient.id, tourId: this.tour.id, type: type}).then((data) => {
        varForThis.showMediaDialog = true;
      });
      this.mediaDialogType = type;
    },
    updateLanguages () {
      let newOrder = [];
      for (let lang of this.tourLanguages) {
        newOrder.push({
          id: lang.id,
          order: lang.order
        });
      }
      this.updateTourLanguages({tourId: this.tour.id, languageOrder: newOrder}).then(() => {
        this.loadTourLanguageList(this.tour.id);
      });
    },
    disableLanguage (languageId) {
      return this.disableLanguages.includes(languageId);
    }
  },
  mounted () {
    this.tour = this.currentTour;
    this.defaultTriSet['defaultActivate'] = this.tour.defaultActivate;
    this.defaultTriSet['defaultRadiusDistance'] = this.tour.defaultRadiusDistance;
    this.defaultTriSet['defaultTolerance'] = this.tour.defaultTolerance;
    this.defaultTriSet['defaultDelay'] = this.tour.defaultDelay;
    this.defaultTriSet['timezone_id'] = this.tour.timezone_id;
    this.updateCurDupli(this.defaultTriSet);
    if (this.tour.id !== '') {
      this.loadTourLanguageList(this.tour.id);
      this.loadTourLibrary({clientId: this.currentClient.id, tourId: this.tour.id});
    }
    this.loadLanguageList();
    this.loadTimezones();
  }
};
</script>
<style lang="scss" scoped>
.tour-settings {
    .md-card-actions {
        margin-left: -22px;
    }

    .md-field {
        margin-right: 22px;
    }

    .md-field {
        float: left;
        width: 117px;
    }

    .md-field.wide {
        width: 400px;
    }

    .md-input {
        height: 36px;
        width: 20px;
    }

    .md-list-item-text p {
        overflow-wrap: break-word;
    }

    .media-section {
        .md-icon-button {
            width: 20px;
            height: 20px;
            margin-top: 14px;

            &.md-primary:hover {
                background: #00788A !important;
            }

            .hover-buttons > .md-icon {
                font-size: 14px !important;
            }
        }
    }

    .global-section {
        .md-icon-button {
            width: 24px;
            height: 40px;
            margin-top: 10px;
            margin-left: 0px;

            &.md-primary:hover {
                background: #00788A !important;
            }

            .hover-buttons > .md-icon {
                font-size: 16px !important;
            }
        }
    }

    .wrap.scroll-list {
        -webkit-box-shadow: none !important;
        -moz-box-shadow: none !important;
        box-shadow: none !important;
    }

    .media-tab .scroll-list {
        height: calc(100vh - 64px);
    }
}

.changeFontSize {
    font-size: 21px;
}

.moveLeftContent {
    padding-left: 20px;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
    margin: 0 8px;
    float: left;
    width: 19%;
    padding: 8px !important;
}

.full-btnDelete {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

.OverflowShowDialog {
    overflow-y: auto;
}

.scroll-listmy {
    box-shadow: 5px 0 5px -2px #888;
}

.as-sortable-item {
    display: block !important;
    background: rgba(0, 168, 202, 0.12) !important;
}

.as-sortable-item .as-sortable-item-handle {
    display: block !important;
    color: #00788A;
}

.as-sortable-item .delete-btn {
    display: block;
    opacity: 1;
}

.small-modal {
    overflow-y: scroll;
}

.tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
}

.map-page .scroll-list {
    overflow: auto;
}

.tooltip .tooltiptext {
    // visibility: hidden;
    width: 400px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    bottom: 100%;
    left: 50%;
    margin-left: -60px;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}


.md-ripple span {
    background: #545454;
    color: #fff;
    white-space: break-spaces;
    border-radius: 4px;
    padding: 8px;
    position: absolute;
    width: 280px;
    left: 145px;
    font-size: 12px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

.md-checkbox.language-checkbox.md-theme-default.md-checked.md-disabled  {
    color: #b9b9b9;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TourSettings.vue